module.exports = __webpack_public_path__ + "img/error-404.e02632ed.svg";